import { Currency } from "@Types/api/price";
import { Locale } from "./";

export interface Localization {
  currency: Currency;
  locale: Locale;
}

export interface LocalizationMapping {
  [key: string]: Localization;
}

// From production:
// puts Localization.preload(:country).map { |l| [l.tag, { locale: l.locale, currency: l.country&.currency } ] }.to_h.to_json
export const localizationMapping: LocalizationMapping = {
  be: { locale: "fr", currency: "EUR" },
  "ch-fr": { locale: "fr", currency: "EUR" },
  en: { locale: "en", currency: "EUR" },
  es: { locale: "es", currency: "EUR" },
  "es-ES": { locale: "es", currency: "EUR" },
  fr: { locale: "fr", currency: "EUR" },
  "fr-FR": { locale: "fr", currency: "EUR" },
  ie: { locale: "en", currency: "EUR" },
  it: { locale: "it", currency: "EUR" },
  "it-IT": { locale: "it", currency: "EUR" },
  lu: { locale: "fr", currency: "EUR" },
  uk: { locale: "en", currency: "GBP" },
  us: { locale: "en", currency: "USD" },
};

export const locationToLocalization = (location: { pathname: string }): Localization => {
  const localizationSlug = location.pathname.split("/", 2)[1];
  const documentLang = document.documentElement.lang;
  const documentLangMapping = localizationMapping[documentLang];

  return localizationMapping[localizationSlug] || documentLangMapping || localizationMapping.en;
};
